import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { AssetCaptionType } from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetCaptions';
import {
  transformCustomCategories,
  transformCustomFilters,
} from '../../../../../../../BatchTicket/components/DynamicAsset/constants';

import { PublicOfferProduct } from '.';

export const publicOfferTableHead: TableHeadItemRecurse[] = [
  { title: 'Tipo Oferta', orderValue: 'offerType' },
  { title: 'Nome', orderValue: 'offerName', flex: 2 },
  { title: 'Cód. Isin', orderValue: 'isinCode' },
  { title: 'Alteração', orderValue: 'alterationDateNormalized' },
  { title: 'Negociação', orderValue: 'negotiationDateNormalized' },
  { title: 'Liquidação', orderValue: 'liquidityDateNormalized' },
  { title: 'Perfil', orderValue: 'suitabilityProfile' },
  { title: 'Limitador', orderValue: 'limiter', flex: 1.5 },
];

export const availableProductPublicOfferConstant = {
  id: 'publicOffers',
  title: 'Ofertas Públicas',
  color: 'product.ofertapublica' as ColorTypes.Option,
  principalComponent: PublicOfferProduct,
  marketStatusSelector: emptyMarketStatusQuery,
  tableHead: publicOfferTableHead,
  hideTableHead: false,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [...transformCustomFilters(customFilters, 1)];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'publicOfferingType',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'publicOfferingType'),
  captions: [] as AssetCaptionType[],
  hasRefresher: false,
} as const;
